export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Guide video e assistenza",
    guidesTip: "Guide e assistenza",
    availabilityPricesTitle: "Disponibilità e Tariffe",
    hotelCalendarSubtitle: "Disponibilità e prenotazioni per camera",
    availabilityPricesSubtitle: "Prezzi, disponibilità e soggiorno minimo",
  },
  maquetaNav: {
    guidesAria: "Guide video e assistenza",
    guidesTip: "Guide e assistenza",
    novedadesAria: "Novità del sistema",
    novedadesTip: "Novità",
    tourTip: "Novità: tour guidato",
    tourAria: "Apri il tour delle novità",
    backToPanel: "Torna al pannello",
    accountTitle: "Impostazioni dell'account",
    agentIaTitle: "Agente IA",
    directBookingsTitle: "Prenotazioni dirette",
    listingsTitle: "Impostazioni degli annunci",
  },
  navMovil: {
    menuTitle: "Menu",
    home: "Home",
    calendar: "Calendario",
    reservations: "Prenotazioni",
    checkins: "Check-in",
    housekeeping: "Pulizie",
    channels: "Canali di prenotazione",
    settings: "Impostazioni",
    settingsDesktopOnly: "Disponibile solo nella versione desktop",
    experiences: "Esperienze",
  },
  register: {
    terms: "Regolamento",
    privacy: "Informativa sulla privacy",
    loginError: "Errore durante l'accesso.",
  },
  buttonSave: {
    savingRoom: "Salvataggio della camera...",
  },
  firstForm: {
    name: "Nome",
    phone: "Telefono",
  },
  final: {
    guestsRegistered: "Ospiti registrati",
    registrationsCompleted: "Registrazioni completate",
    registrationTime: "Ora della registrazione: ",
    shareRegistrationLink: "Condividi il link di registrazione",
  },
  scannerPdf417: {
    captureCode: "Cattura codice",
    focusInstruction: "Inquadra e cattura il codice a barre del tuo documento",
  },
  configNotifications: {
    title: "Notifiche",
    propertyLabel: "Struttura",
    phoneInstruction: "Inserisci il numero di telefono che desideri utilizzare per ricevere le notifiche delle richieste di servizio o dei check-in effettuati dagli ospiti tramite WhatsApp",
    saveWhatsapp: "Salva WhatsApp",
    editWhatsapp: "Modifica WhatsApp",
    configTitle: "Impostazioni",
    serviceNotifications: "Notifiche dei servizi",
    checkinNotifications: "Notifiche di check-in",
    active: "Attive",
    inactive: "Inattive",
    whatsappRequired: "Devi inserire il WhatsApp",
    swalTitle: "WhatsApp per le notifiche della tua struttura",
    swalText: "Riceverai tutte le notifiche dei servizi richiesti e dei check-in degli ospiti ",
    cancel: "Annulla",
    whatsappAdded: "WhatsApp aggiunto con successo",
  },
  modalPoliceData: {
    headerSub: "Inserisci le tue credenziali di accesso al sistema",
    closeAria: "Chiudi",
    entityName: "Nome dell'ente",
    usernamePlaceholder: "Inserisci il tuo nome utente",
    passwordPlaceholder: "Inserisci la tua password",
    hide: "Nascondi",
    show: "Mostra",
    lessorExample: "Es.: 12345",
    establishmentExample: "Es.: 67890",
    saving: "Salvataggio…",
    listingNotFound: "Annuncio associato non trovato.",
    saveFailed: "Impossibile salvare SES Hospedajes.",
  },
  notificaciones: {
    title: "Notifiche",
    propertyLabel: "Struttura",
    phoneInstruction: "Inserisci il numero di telefono che desideri utilizzare per ricevere le notifiche delle richieste di servizio o dei check-in effettuati dagli ospiti tramite WhatsApp",
    saveWhatsapp: "Salva WhatsApp",
    editWhatsapp: "Modifica WhatsApp",
    configTitle: "Impostazioni",
    serviceNotifications: "Notifiche dei servizi",
    checkinNotifications: "Notifiche di check-in",
    active: "Attive",
    inactive: "Inattive",
    whatsappRequired: "Devi inserire il WhatsApp",
    swalTitle: "WhatsApp per le notifiche della tua struttura",
    swalText: "Riceverai tutte le notifiche dei servizi richiesti e dei check-in degli ospiti ",
    cancel: "Annulla",
    whatsappAdded: "WhatsApp aggiunto con successo",
  },
  admins: {
    listTitle: "Elenco manager",
    newManager: "Nuovo manager",
    today: "Oggi",
    thName: "Nome",
    thEmail: "Email",
    thRegistered: "Registrato",
    edit: "Modifica",
    delete: "Elimina",
    userLabel: "Nome utente",
    emailLabel: "Email",
    passwordLabel: "Password",
    cancel: "Annulla",
    save: "Salva",
    createdOk: "Creato correttamente",
    requestError: "Errore nella richiesta",
    updatedOk: "Aggiornato correttamente",
    deletedOk: "Eliminato correttamente",
  },
};
